import { usePopup } from 'hooks/usePopup';
import { ProposedOrganizationDto } from 'services/user/userService.dto';

import AddOrganization from './AddOrganization';
import ProposedOrganization from './ProposedOrganization';
import { OrganizationFormData } from './useAddOrganizationForm';

export const useAddOrganizationPopup = () => {
  const { showPopup, hidePopup } = usePopup();

  const finishWithOrganization = (
    onSelected: (organization: OrganizationFormData) => void,
    organization: OrganizationFormData
  ) => {
    hidePopup();
    onSelected(organization);
  };

  const showProposedOrganizationPopup = (
    onSelected: (organization: OrganizationFormData) => void,
    enteredOrganization: OrganizationFormData,
    proposedOrganization: ProposedOrganizationDto
  ) => {
    showPopup(
      <ProposedOrganization
        enteredOrganization={enteredOrganization}
        proposedOrganization={proposedOrganization}
        onSelected={organization => finishWithOrganization(onSelected, organization)}
        onEditEntered={() => {
          hidePopup();
          showAddOrganizationPopup(onSelected, enteredOrganization);
        }}
      />,
      { keepPopups: true }
    );
  };

  const showAddOrganizationPopup = (
    onSelected: (organization: OrganizationFormData) => void,
    organization?: OrganizationFormData
  ) => {
    showPopup(
      <AddOrganization
        organization={organization}
        onSelected={selected => finishWithOrganization(onSelected, selected)}
        onProposed={(entered, proposed) => {
          hidePopup();
          showProposedOrganizationPopup(onSelected, entered, proposed);
        }}
        onBack={() => hidePopup()}
      />,
      { keepPopups: true }
    );
  };

  return { showAddOrganizationPopup };
};
